import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Accordion, Form } from "react-bootstrap";
// import { validateHTMLColorHex } from "validate-color";
import Spinner2 from "../Spinner2";
import { toast } from "react-toastify";
import CustomUploader from "./CustomizationUploader";
const Customization = () => {
  let bearerToken = localStorage.getItem("jwt_token");
  const defaultWidgetData = useMemo(
    () => ({
      // logo_url: "",
      // launcher_logo_url: "",
      // action_color: "",
      // background_color: "",
      // home_text_color: "",
      // launcher_logo: "",
      // launcher_positioning: "",
      // gradient_top_left: "",
      // gradient_bottom_right: "",
      // header_background: "",
      // footer_background: "",
      brand_logo_url: "",
      display_footer_credit: "false",
    }),
    []
  );

  // const [customLauncherLogo, setCustomLauncherLogo] = useState(null);
  const [newLogo, setNewLogo] = useState(null);
  const [newDisplayFooterCredit, setNewDisplayFooterCredit] = useState(false);

  const [widgetData, setWidgetData] = useState(defaultWidgetData);
  const [loading, setLoading] = useState(false);
  const config1 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };

  // const handleSave = async () => {
  //   try {
  //     // Create a copy of the current widget data to ensure modifications are captured
  //     let updatedWidgetData = { ...widgetData };

  //     if (customLauncherLogo) {
  //       const response = await uploadFileToWP(bearerToken, customLauncherLogo);
  //       if (response?.guid?.rendered)
  //         updatedWidgetData.launcher_logo_url = response.guid.rendered;
  //     }

  //     // Update the widgetData state before calling storeData
  //     setWidgetData(updatedWidgetData);

  //     // Save the updated widget data to the database
  //     await storeData(updatedWidgetData);
  //   } catch (err) {
  //     console.error("Error saving widget data:", err);
  //     toast("An error occurred while saving the widget data.");
  //   }
  // };

  const handleSaveLogo = async () => {
    try {
      // Create a copy of the current widget data to ensure modifications are captured
      let updatedWidgetData = {};

      if (newLogo) {
        const response = await uploadFileToWP(bearerToken, newLogo);
        if (response?.guid?.rendered)
          updatedWidgetData.brand_logo_url = response.guid.rendered;
      }

      updatedWidgetData.display_footer_credit = `${newDisplayFooterCredit}`;
      console.log({ updatedWidgetData });
      // Save the updated widget data to the database
      await storeData(updatedWidgetData);
    } catch (err) {
      console.error("Error saving widget data:", err);
      toast("An error occurred while saving the widget data.");
    }
  };
  const uploadFileToWP = async (platformToken, file) => {
    const form = new FormData();
    form.append("file", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/wp-json/wp/v2/media`,
        form,
        {
          headers: {
            Authorization: `Bearer ${platformToken}`,
          },
        }
      );
      console.log("ressssssss ", response.data);
      return response.data;
    } catch (err) {
      const errorDetails = err.response?.data || err.message || "Unknown error";
      throw new Error(`File upload failed: ${errorDetails}`);
    }
  };
  const storeData = (data) => {
    axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}/wp-json/custom-api/v1/store-dynamic-data`,
        data,
        config1
      )
      .then((res) => {
        toast.success("Saved Successfully");
        setLoading(true);

        getData()
          .then((res) => {
            console.log("getData res: ", res);
            setNewDisplayFooterCredit(
              res.data.display_footer_credit === "true"
            );
            setWidgetData((prev) => ({ ...prev, ...res.data }));
          })
          .catch((err) => console.log(err))
          .finally(() => setLoading(false));
      })
      .catch((err) => toast.error(err.message));
  };

  const getData = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${process.env.REACT_APP_API_ENDPOINT}/wp-json/custom-api/v1/get-dynamic-data`,
          config1
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  };

  useEffect(() => {
    setLoading(true);
    getData()
      .then((res) => {
        console.log("getData res: ", res);
        setNewDisplayFooterCredit(res.data.display_footer_credit === "true");
        setWidgetData((prev) => ({ ...prev, ...res.data }));
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  return loading ? (
    <Spinner2 />
  ) : (
    <>
      <Accordion defaultActiveKey="0">
        {/*
        <Accordion.Item eventKey="0">
          <Accordion.Header>Widget Colors</Accordion.Header>
          <Accordion.Body>
            <p className="fw-bold">Action Color</p>
            <p>Used in buttons, links and more to highlight and emphasize.</p>
            <Form.Control
              type="color"
              id="actionColorInput"
              defaultValue={
                widgetData.action_color &&
                validateHTMLColorHex(widgetData.action_color)
                  ? widgetData.action_color
                  : "#563d7c"
              }
              title="Choose your color"
              onChange={(e) => {
                console.log();
                setWidgetData((prev) => ({
                  ...prev,
                  action_color: e.target.value,
                }));
              }}
              // onChange={(e) => console.log("bfdgf", e)}
            />
            <p className="mt-3 fw-bold">Background color</p>
            <p>Used in the header across all Spaces</p>
            <Form.Control
              type="color"
              id="backgroundColorInput"
              defaultValue={
                widgetData.background_color &&
                validateHTMLColorHex(widgetData.background_color)
                  ? widgetData.background_color
                  : "#563d7c"
              }
              title="Choose your color"
              onChange={(e) =>
                setWidgetData((prev) => ({
                  ...prev,
                  background_color: e.target.value,
                }))
              }
            />
          </Accordion.Body>
        </Accordion.Item>
        */}
        {/* <Accordion.Item eventKey="1">
          <Accordion.Header>Widget Home</Accordion.Header>
          <Accordion.Body>
            <CustomUploader
              label={"Logo"}
              setCustomLogo={setCustomLogo}
              placeholder={widgetData.logo_url}
            />

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label className="fw-bold">Header background</Form.Label>
              <div className="mb-3">
                <Form.Check // prettier-ignore
                  type={"radio"}
                  id={`background`}
                  name="headerBg"
                  label={`Use the background color`}
                  onClick={() =>
                    setWidgetData((prev) => ({
                      ...prev,
                      header_background: "background",
                    }))
                  }
                />
                {widgetData?.header_background === "background" && (
                  <Form.Control
                    type="color"
                    id="backgroundColorInput"
                    className="my-3"
                    defaultValue={
                      widgetData.background_color &&
                      validateHTMLColorHex(widgetData.background_color)
                        ? widgetData.background_color
                        : "#563d7c"
                    }
                    style={{ cursor: "not-allowed" }}
                    title="Choose your color"
                    disabled={true}
                  />
                )}
                <Form.Check // prettier-ignore
                  type={"radio"}
                  id={`gradient`}
                  name="headerBg"
                  label={`Gradient`}
                  onClick={() =>
                    setWidgetData((prev) => ({
                      ...prev,
                      header_background: "gradient",
                    }))
                  }
                />
                {widgetData?.header_background === "gradient" && (
                  <div className="row mb-3">
                    <Form.Group
                      controlId="formFile"
                      className="my-3 col-md-3 col-xl-2"
                    >
                      <Form.Label>Top left</Form.Label>
                      <Form.Control
                        type="color"
                        id="topLeftColorInput"
                        defaultValue={
                          widgetData.gradient_top_left &&
                          validateHTMLColorHex(widgetData.gradient_top_left)
                            ? widgetData.gradient_top_left
                            : "#563d7c"
                        }
                        title="Choose your color"
                      />
                    </Form.Group>
                    <Form.Group
                      controlId="formFile"
                      className="mb-3 col-md-3 col-xl-2"
                    >
                      <Form.Label>Bottom right</Form.Label>
                      <Form.Control
                        type="color"
                        id="bottomRightColorInput"
                        defaultValue={
                          widgetData.gradient_bottom_right &&
                          validateHTMLColorHex(widgetData.gradient_bottom_right)
                            ? widgetData.gradient_bottom_right
                            : "#563d7c"
                        }
                        title="Choose your color"
                      />
                    </Form.Group>
                  </div>
                )}
              </div>
            </Form.Group>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Text Color</Form.Label>
              <div className="mb-3">
                <Form.Check // prettier-ignore
                  type={"radio"}
                  id={`Dark`}
                  name="group1"
                  label={`Dark`}
                  onClick={() =>
                    setWidgetData((prev) => ({
                      ...prev,
                      home_text_color: "Dark",
                    }))
                  }
                />
                <Form.Check // prettier-ignore
                  type={"radio"}
                  id={`Light`}
                  name="group1"
                  label={`Light`}
                  onClick={() =>
                    setWidgetData((prev) => ({
                      ...prev,
                      home_text_color: "Light",
                    }))
                  }
                />
              </div>
            </Form.Group>
          </Accordion.Body>
        </Accordion.Item> */}
        {/* <Accordion.Item eventKey="2">
          <Accordion.Header>Launcher</Accordion.Header>
          <Accordion.Body>
            <CustomUploader
              label={"Custom launcher"}
              setCustomLogo={setCustomLauncherLogo}
              placeholder={widgetData.launcher_logo_url}
              background={widgetData.action_color}
            />
          </Accordion.Body>
        </Accordion.Item> */}
        {/* <Accordion.Item eventKey="3">
          <Accordion.Header>Footer</Accordion.Header>
          <Accordion.Body>
            <Form.Control
              type="color"
              id="footerColorInput"
              className="my-3"
              defaultValue={
                widgetData.footer_background &&
                validateHTMLColorHex(widgetData.footer_background)
                  ? widgetData.footer_background
                  : "#ffffff"
              }
              title="Choose footer color"
              onChange={(e) => {
                console.log();
                setWidgetData((prev) => ({
                  ...prev,
                  footer_background: e.target.value,
                }));
              }}
            />
          </Accordion.Body>
        </Accordion.Item> */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>Logo & Credits</Accordion.Header>
          <Accordion.Body>
            <Form>
              <CustomUploader
                label={"Logo"}
                setCustomLogo={setNewLogo}
                placeholder={widgetData.brand_logo_url}
                background={"#ffffff"}
              />

              <Form.Check // prettier-ignore
                type="switch"
                id="custom-switch"
                label="Show Footer Credits to SolvYaAI"
                checked={newDisplayFooterCredit}
                onChange={(e) => {
                  console.log("cvfd", e.target.checked);
                  setNewDisplayFooterCredit(e.target.checked);
                }}
              />
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <button className="btn" onClick={handleSaveLogo}>
        Save
      </button>
    </>
  );
};

export default Customization;
